export const dashboardKeys = {
  all: ['dashboard'] as const,

  activityLists: () => [...dashboardKeys.all, 'list'] as const,
  activityList: args => [...dashboardKeys.activityLists(), args] as const,

  expiringDocuments: () => [...dashboardKeys.all, 'expiring-document'] as const,
  expiringDocument: args => [...dashboardKeys.expiringDocuments(), args] as const,

  widgets: () => [...dashboardKeys.all, 'widget'] as const,
  widget: args => [...dashboardKeys.widgets(), args] as const,
};
